// El mismo número y el mismo patrón de link que usa la app de alumnos (athlete/layout.tsx).
const NUMERO = '56977481530';

export function enlaceWhatsApp(mensaje = 'Hola Agustín, necesito ayuda con mi suscripción') {
  return `https://wa.me/${NUMERO}?text=${encodeURIComponent(mensaje)}`;
}

// Grupo de WhatsApp de AU Coaching: lo ven quienes contratan en /welcome.
export const ENLACE_GRUPO_WHATSAPP = 'https://chat.whatsapp.com/GzGuKaiPhxFFDmzF00GL2T';
